import { Flex, Typography } from 'antd';
import noDataImg from '../Assets/Images/noData.png';
import { useTranslation } from 'react-i18next';

interface NoDataProps {
  imgSource?: string;
  message?: string;
}

export const NoData = ({
  imgSource,
  message,
}: NoDataProps): React.ReactElement => {
  const { t } = useTranslation();
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        width: '100%',
        flex: 1,
        minHeight: 0,
      }}
    >
      <img
        src={imgSource ?? noDataImg}
        alt="noInternshipProcessesImg"
        style={{
          width: '100%',
          maxWidth: '280px',
          height: 'auto',
          padding: '24px',
          opacity: 0.5,
        }}
      />

      <Flex justify="center" align="center" vertical>
        <Typography.Text
          style={{ fontSize: '16px', fontWeight: 500, color: '#8c8c8c' }}
        >
          {message ?? t('noDataComp.noData')}
        </Typography.Text>
      </Flex>
    </div>
  );
};
